__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@axa-fr/react-oidc", "7.25.13", () => (() => (__webpack_require__(60375))), 1);
			register("cf-app-shell", "0.134.0", () => (__webpack_require__.e(763).then(() => (() => (__webpack_require__(5763))))));
			register("mintel-taskbar", "6.28.1", () => (Promise.all([__webpack_require__.e(699), __webpack_require__.e(951), __webpack_require__.e(910), __webpack_require__.e(971)]).then(() => (() => (__webpack_require__(92951))))));
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(40961))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(96540))), 1);
			register("wouter", "2.12.1", () => (() => (__webpack_require__(79779))), 1);
			initExternal(15269);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};